// assets/product-qty-input.js

class ProductQtyInput extends Global.Core {
    constructor() {
        super();
        // FIX 2: Update selectors to match your actual HTML from product-qty-selector.liquid
        this.elements = {
            'input': '[data-element="input"]',
            'decrementBtn': '[data-element="button-minus"]',
            'incrementBtn': '[data-element="button-plus"]',
        };
    }

    // FIX 1: Rename render() to connectedCallback()
    // This is the standard method that runs when a custom element is added to the page,
    // which is crucial because this component is re-added every time a variant changes.
    connectedCallback() {

        // Bind events to the buttons
        this.$('decrementBtn', { click: this._onDecrement.bind(this) });
        this.$('incrementBtn', { click: this._onIncrement.bind(this) });
        this.$('input', { change: this._onInputChange.bind(this) });

        // Initial check for button states
        this._updateButtonStates();
    }

    _onDecrement(e) {
        e.preventDefault();
        const currentValue = parseInt(this.$('input').value, 10);
        if (currentValue > 1) {
            this.$('input').value = currentValue - 1;
            this._dispatchChangeEvent();
        }
    }

    _onIncrement(e) {
        e.preventDefault();
        const currentValue = parseInt(this.$('input').value, 10);
        const max = this.$('input').getAttribute('max');
        
        if (max && currentValue >= parseInt(max, 10)) {
            return; // Don't increment if at max
        }
        
        this.$('input').value = currentValue + 1;
        this._dispatchChangeEvent();
    }

    _onInputChange() {
        this._updateButtonStates();
    }

    _dispatchChangeEvent() {
        // This tells other parts of the theme that the quantity has changed
        this.$('input').dispatchEvent(new Event('change', { bubbles: true }));
        this._updateButtonStates();
    }
    
    // FIX 3: Add logic to manage the disabled state of the buttons for better UX
    _updateButtonStates() {
        const currentValue = parseInt(this.$('input').value, 10);
        const max = this.$('input').getAttribute('max');
        
        this.$('decrementBtn').disabled = currentValue <= 1;
        
        if (max) {
            this.$('incrementBtn').disabled = currentValue >= parseInt(max, 10);
        } else {
            this.$('incrementBtn').disabled = false;
        }
    }
}

customElements.define('product-qty-input', ProductQtyInput);